import React from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import Visibility from "@material-ui/icons/Visibility";
import { useTranslation } from "react-i18next";
import Link from "react-router-dom/Link";
import { useStyles } from "components/layout/CommonStyles";
import { GetGeneralPermissionForAction } from "utils/permissions/GetGeneralPermissionForAction";
import { isDateToday } from "utils/dates/isDateToday";
import { Screen, Allow } from "global/constants";


const MyClockRecordTableActions = props => {
    if (localStorage.getItem("auth-token") !== null) {
        var auth = JSON.parse(localStorage.getItem("auth-token"));
    }
    const classes = useStyles();
    const [t] = useTranslation();
    const { item , registersActivity} = props;

    return (
        <React.Fragment>
            {GetGeneralPermissionForAction(Screen.MY_CLOCK_RECORD, Allow.READ) &&
            <Link to={`/MyActivities/${item.id}/view`}>
                <Tooltip title={t("GENERAL.view")} aria-label="details" placement="top">
                        <IconButton className={classes.iconsTableActions} >
                            <Visibility />
                        </IconButton>
                </Tooltip>
            </Link>
            }
            {registersActivity && GetGeneralPermissionForAction(Screen.MY_CLOCK_RECORD, Allow.EDIT) && ( !isDateToday(item.date) || item.leaveTime ) && 
            <Link to={`/MyActivities/${item.id}/edit`} >
                <Tooltip title={t("GENERAL.edit")} aria-label="edit" placement="top">
                    <IconButton className={classes.iconsTableActions} >
                        <Edit />
                    </IconButton>
                </Tooltip>
            </Link>       
            } 
            
        </React.Fragment>
    )
};

export default MyClockRecordTableActions;